<template>
  <br />
</template>

<script>
export default {
  created() {
    this.fnLogout();
  },
};
</script>
